"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAnalyticsNoop = exports.createPlatformAnalytics = void 0;
var perf_metrics_1 = require("../perf-metrics");
var PlatformAnalyticsNoop = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function class_1(overriddenMicromessages) {
        /*noop*/
    }
    class_1.prototype.collect = function () {
        /*noop*/
    };
    class_1.prototype.publish = function () {
        /*noop*/
    };
    class_1.prototype.publishClientSidePayload = function () {
        /*noop*/
    };
    class_1.prototype.fireAmcvBeaconWithTraceId = function () {
        /*noop*/
    };
    class_1.prototype.markPageUsable = function () {
        /*noop*/
    };
    class_1.prototype.trackEvent = function () {
        /*noop*/
    };
    class_1.prototype.getPerformanceMetrics = function () {
        return perf_metrics_1.performanceMetrics;
    };
    class_1.prototype.getClientLog = function () {
        /*noop*/
    };
    return class_1;
}());
exports.PlatformAnalyticsNoop = PlatformAnalyticsNoop;
function createPlatformAnalytics(overridenMicromessages) {
    if (typeof window === 'object') {
        var PlatformAnalytics = require('platform-analytics-prime');
        return new PlatformAnalytics({ overridenMicromessages: overridenMicromessages, isPwa: true, isPublishWebVitals: true });
    }
    return new PlatformAnalyticsNoop(overridenMicromessages);
}
exports.createPlatformAnalytics = createPlatformAnalytics;
//# sourceMappingURL=platform-analytics-factory.js.map